<portal-sub-nav [force]="force" route="enterprise-calendar">
  <!-- Time Table -->
  <portal-sub-nav-item route="enterprise-time-table">
    <ng-template portalTransclude>
      <span>{{ 'menu.timeTable' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Holiday Lists -->
  <portal-sub-nav-item route="enterprise-holiday-lists">
    <ng-template portalTransclude>
      <span>{{ 'menu.holidayLists' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>
</portal-sub-nav>
